import { render, staticRenderFns } from "./SweetSpotSetup.vue?vue&type=template&id=452e5b7b&scoped=true"
import script from "./SweetSpotSetup.vue?vue&type=script&lang=js"
export * from "./SweetSpotSetup.vue?vue&type=script&lang=js"
import style0 from "./SweetSpotSetup.vue?vue&type=style&index=0&id=452e5b7b&prod&scoped=true&lang=css"
import style1 from "./SweetSpotSetup.vue?vue&type=style&index=1&id=452e5b7b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452e5b7b",
  null
  
)

export default component.exports